export default __webpack_public_path__ + "static/media/ComputadorExchange.7f17ecdf.png";